import React from 'react';
import { resolveInternationalPhone } from '../../../utils/phone';
import Pagination from "../../plugins/Pagination";
import usePage from '../../../hooks/usePage';

import { BsWhatsapp } from 'react-icons/bs';

const ModeTable = ({ listStages, setShowContactInfo, setShowContacts, setDataContactInfo, validation }) => {
    const { page, setPage, byPage, resetPage } = usePage();
    return (
        <>
            <div className="container-fluid mt-2 px-0" style={{ height:"83%", overflowY:"auto", overflowX:"none" }}>
                <table className="table table-striped table-campaigns">
                    <thead style={{ position: "sticky", top: "-1px", zIndex: "99" }}>
                        <tr>
                            {/* <th>Acciones</th> */}
                            <th>Etiquetas</th>
                            <th>Nombre</th>
                            <th>Teléfono</th>
                            <th>Etapa</th>
                        </tr>
                    </thead>
                    <tbody>
                    {listStages.length > 0 && listStages.map((stage) => (
                        stage.prospects.map((prospect) => (
                            <tr 
                                key={prospect._id} 
                                onClick={() => {
                                    setShowContactInfo(true);
                                    setShowContacts(false)
                                    setDataContactInfo(prospect);
                                }}
                            >
                                {/* <td>
                                    <div className="row justify-content-around">
                                        <BsWhatsapp
                                            className="mr-1" 
                                            style={{ fontSize: "23px", color: "#00a884" }} 
                                            title="Enviar mensaje"
                                            // onClick={prospect.wpp_enabled ? () => {
                                            //     navigate(`/home/chat`, { 
                                            //     state: { 
                                            //         idContact: prospect._id,
                                            //         isChat: true
                                            //     } 
                                            //     })
                                            // } : undefined}
                                            disabled={!prospect.wpp_enabled}
                                        />
                                    </div>
                                </td> */}
                                <td style={{width: "20%"}}>
                                    <ul className="d-flex flex-wrap" style={{lineHeight: "1.8"}}>
                                        {prospect.tags.length > 0 && prospect.tags.filter(tag => tag !== null && tag !== undefined).slice(0, 3).map((tag, t) => (
                                            <li
                                                key={t}
                                                className="px-2 py-0 mr-2 border-0"
                                                style={{
                                                    backgroundColor: tag.color || "#cccccc",
                                                    fontSize: "0.75rem",
                                                    color: "#fff",
                                                    borderRadius: "7px",
                                                }}
                                            >
                                                {tag.title.length >= 6
                                                    ? tag.title.substr(0, 6) + "..."
                                                    : tag.title
                                                }
                                            </li>
                                        ))}
                                        {prospect.tags && prospect.tags.length > 3 && (
                                            <li className="px-0 py-0 mr-2 border-0" style={{fontSize: "0.8rem"}}>
                                                +1
                                            </li>
                                        )}
                                    </ul>
                                </td>
                                <td>
                                    {prospect.name}
                                </td>
                                <td>
                                    +{resolveInternationalPhone(prospect.callingCode, prospect.phone)}
                                </td>
                                <td>
                                    {stage.name}
                                </td>
                            </tr>
                        ))
                    ))}
                    </tbody>
                </table>
                {validation && (
                    <div className="text-center mt-3">
                        <div className="empty">
                        <h1>No tienes prospectos</h1>
                        </div>
                    </div>
                )}
            </div>

            <footer>
                <div className="row">
                    <div className="col-md-8"></div>

                    <div className="col-md-4">
                        <Pagination
                            totalData={listStages.length}
                            byPage={byPage}
                            setPage={setPage}
                        />
                    </div>
                </div>
            </footer>
            </>
    )
}

export default ModeTable;
